<template>
  <div class="cashflow-type-mock">
    <div class="title">
      <span>הוצאות {{ cashflowType }}</span>
    </div>

    <expense-progress :recommended-or-expected-label="'מומלץ להוציא עד'"
                      :up-to-now-label="'יצא עד עכשיו'"
                      :pending="true" />

    <mock-sections-label :title="sectionsTitle" />
  </div>
</template>

<script>
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import MockSectionsLabel from './MockSectionsLabel.vue';

export default {
  name: 'CashflowTypeMock',
  mixins: [CashflowAnalytics],
  components: {
    ExpenseProgress,
    MockSectionsLabel,
  },
  props: {
    cashflowType: {
      type: String,
      required: true,
    },
  },
  computed: {
    sectionsTitle() {
      return `פירוט הוצאות ${this.cashflowType}`;
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-mock {
    @include cashflow-card;
    margin-bottom: 16px;
    color: $riseup_gray_1;
    border-radius: 3px;
    border: dashed 1px $riseup_gray_1;

    .title {
      color: $riseup_gray_1;
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_gray_1;
    }

    .cashflow-type-background-color {
      background-color: $riseup_gray_0;
    }
  }

</style>
